import {useEffect} from 'react';
import {Asset} from '@deviceinsight/ng-ui-api-client';

import type {ButtonInfo} from '../floorplan/types';
import {addButtonInteractivity} from '../common/utils';
import {getAssetDeviceType} from '../../ruleengine/ruleEditHelpers';
import {SBOX_TYPE} from '../../../modules/common/consts';
import {WidgetSvg} from '../floorplan/hooks/types';

const useButtonInteractivity = (
	svgRootObj: WidgetSvg | undefined,
	canPressButton: boolean,
	setButtonInfo: (arg0: ButtonInfo) => void,
	asset: Asset
) => {
	useEffect(() => {
		if (svgRootObj && asset) {
			const type = getAssetDeviceType(asset);

			if (type === SBOX_TYPE) {
				const {id: assetId} = asset;
				const assetIdString = assetId.toString();
				addButtonInteractivity(svgRootObj, assetIdString, canPressButton, setButtonInfo);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [svgRootObj, canPressButton, asset]);
};

export default useButtonInteractivity;
